(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["index-customer-reviews"] && !Shopify.designMode) return;
  try {
    
$(window).bind("load", function() { 
    var slickDots = $('.testi .slick-dots').width();
	//console.log('INNN ' + slickDots);
	//$('.testi .slick-arrow.prev').css('left','clac(50% - '+slickDots+'px')');
	//$('.testi .slick-arrow.next').css('right','clac(50% - '+slickDots+'px')');
});

  } catch(e) { console.error(e); }
})();
})();
